import { render, staticRenderFns } from "./SalesCategoryDialog.vue?vue&type=template&id=fe948ca6&scoped=true"
import script from "./SalesCategoryDialog.vue?vue&type=script&lang=js"
export * from "./SalesCategoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe948ca6",
  null
  
)

export default component.exports